/*This file was generated by Fumadocs. Do not edit this file directly. Any changes should be made by running the generation command again.*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Upload a cache artifact",
  "description": "Uploads a cache artifact identified by the `hash` specified on the path. The cache artifact can then be downloaded with the provided `hash`.",
  "full": true,
  "_openapi": {
    "method": "PUT",
    "route": "/v8/artifacts/{hash}",
    "toc": [],
    "structuredData": {
      "headings": [],
      "contents": [{
        "content": "Uploads a cache artifact identified by the `hash` specified on the path. The cache artifact can then be downloaded with the provided `hash`."
      }]
    }
  }
};
export let structuredData = {
  "contents": [{
    "content": "Uploads a cache artifact identified by the `hash` specified on the path. The cache artifact can then be downloaded with the provided `hash`."
  }],
  "headings": []
};
export const toc = [];
function _createMdxContent(props) {
  const {APIPage} = props.components || ({});
  if (!APIPage) _missingMdxReference("APIPage", true);
  return _jsxs(_Fragment, {
    children: ["\n", _jsx(APIPage, {
      document: "./.openapi.json",
      operations: [{
        "path": "/v8/artifacts/{hash}",
        "method": "put"
      }],
      webhooks: [],
      hasHead: false
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
